import { RDCornNitrogenApplication } from '@cibo/core'
import CheckRounded from '@mui/icons-material/CheckRounded'
import DoDisturbRounded from '@mui/icons-material/DoDisturbRounded'
import { Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { TraitCellDisplayProps } from '../types'

export const CornNitrogenApplicationCell = ({
  traitId,
  year,
  params,
}: TraitCellDisplayProps<RDCornNitrogenApplication>) => {
  const { t } = useTranslation('@cibo/landmanager/CornNitrogenApplication')
  const detail = params.row.findDetail({ traitId, year })

  if (!detail) return <>--</>

  const answer =
    detail.result === undefined ? '--' : !!detail.result ? t('positive') : t('negative')

  return (
    <Stack direction="row" spacing={1}>
      {detail.result ? (
        <CheckRounded fontSize="small" color="success" />
      ) : (
        <DoDisturbRounded fontSize="small" />
      )}
      <Stack>
        <Typography>{answer}</Typography>
        <Typography variant="body2" color="text.secondary">
          {detail.input?.addedNitrogenStabilizer !== undefined
            ? detail.input?.addedNitrogenStabilizer
              ? t('nitrogenStabilizerAdded')
              : t('nitrogenStabilizerNotAdded')
            : null}
        </Typography>
      </Stack>
    </Stack>
  )
}
